const Pagination = () => {
  return (
    <div className="bbwp-pagination pagination-container d-flex flex-column flex-md-row align-items-center justify-content-between">
      <ul className="pagination mb-3 mb-md-0">
        <li className="page-item disabled">
          <span className="page-link">Page 1 of 48</span>
        </li>

        <li className="page-item active" aria-current="page">
          <button className="page-link" type="button">
            1
          </button>
        </li>
        <li className="page-item">
          <button className="page-link" type="button">
            2
          </button>
        </li>
        <li className="page-item">
          <button className="page-link" type="button">
            3
          </button>
        </li>
        <li className="page-item disabled">
          <span className="page-link">…</span>
        </li>
        <li className="page-item">
          <button className="page-link" type="button">
            48
          </button>
        </li>
        <li className="page-item">
          <button className="page-link" type="button">
            Next »
          </button>
        </li>
      </ul>

      <div className="pagination_page_no d-flex align-items-center">
        <span className="me-2">Page#</span>
        <input
          type="number"
          name="paged"
          value="1"
          className="form-control"
          style={{ maxWidth: "100px" }}
        />
      </div>
    </div>
  );
};

export default Pagination;
